<ion-app>
  <ion-menu side="end" menuId="first" contentId="content1">
    <ion-header>
      <!--ion-toolbar style="color: white;">
          Hoots Battery  {{versionname}} {{staging}}
          <hr style="color: white;">
          <br>
        </!--ion-toolbar-->
    </ion-header>

    <ion-content>
      <br /><br />
      <ion-spinner *ngIf="showSpinner" color="warning"></ion-spinner>
      <ion-list *ngFor="let pages of navigate">
        <ion-menu-toggle auto-hide="true">
          <ion-item [routerLink]="pages.url" routerDirection="forward" style="color: white;" (click)="storeMenuOpen()">
            <ion-icon [name]="pages.icon" slot="start"></ion-icon>
            {{pages.title}}
          </ion-item>
        </ion-menu-toggle>
      </ion-list>

    </ion-content>

    <ion-footer-bar class="bar-stable">

      <ion-list *ngIf="language==='de'">
        <ion-menu-toggle auto-hide="true">
          <ion-item (click)="showVersion()" style="color: white;">
            <span *ngIf="showversioname">{{versionname}}</span>
          </ion-item>
          <ion-item routerLink="systeminfo" routerDirection="forward" style="color: white;">
            Systeminformationen
          </ion-item>
          <ion-item routerLink="kontakt" routerDirection="forward" style="color: white;">
            Kontakt
          </ion-item>
          <!--ion-item routerLink="datenschutz" routerDirection="forward" style="color: white;">
            Datenschutz
          </ion-item>
          <ion-item routerLink="nutzungsbedingungen" routerDirection="forward" style="color: white;">
            Nutzungsbedingungen
          </!--ion-item-->

        </ion-menu-toggle>
      </ion-list>

      <ion-list *ngIf="language==='en'">
        <ion-menu-toggle auto-hide="true">
          <ion-item (click)="showVersion()" style="color: white;">
            <span *ngIf="showversioname">{{versionname}}</span>
          </ion-item>
          <ion-item routerLink="systeminfo" routerDirection="forward" style="color: white;">
            System information
          </ion-item>
          <ion-item routerLink="kontakt" routerDirection="forward" style="color: white;">
            Contact
          </ion-item>
          <!--ion-item routerLink="datenschutz" routerDirection="forward" style="color: white;">
            Privacy policy
          </ion-item>
          <ion-item routerLink="nutzungsbedingungen" routerDirection="forward" style="color: white;">
            Terms of use
          </!--ion-item-->

        </ion-menu-toggle>
      </ion-list>

      <div style="margin: 35px;" class="title">&nbsp;&nbsp;&nbsp;&nbsp;<small>© pei tel Communications GmbH
          2026</small> <br /></div>
    </ion-footer-bar>


  </ion-menu>
  <ion-router-outlet id="content1" [animated]="false"></ion-router-outlet>
</ion-app>
